export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/crypto.worker.b6de4e2fa04f1c889682.worker.js");
}
